import { useEffect } from 'react';
import useFetchAppConstants from './hooks/queries/useFetchConstants';
import AppRoutes from './routes';
import { useDispatch } from 'react-redux';
import { setAppConstants } from './redux/slices/authSlice';
import { setMomentTimezone } from './utils';

const App = () => {
  const { data } = useFetchAppConstants();
  const dispatch = useDispatch();
  useEffect(() => {
    setMomentTimezone(data?.timezone);
    dispatch(setAppConstants(data));
  }, [data, dispatch]);

  return <AppRoutes />;
};

export default App;
